export default __webpack_public_path__ + "5807befc53e2712ba3dc559cdbecbc86.png";